import { chain, filter, toUpper } from "lodash"
import { FACTOR_SENSITIVITY_LOOKBACK_DAYS } from "helpers/factorSensitivity"

const QUERY = `query (
  $modelId: String!,
  $positionSet: PositionSetInput!,
  $base: [PositionSetInput],
  $date: Date!,
  $factorSensitivityType: FactorSensitivityType!,
  $horizon: FactorSensitivityTimeHorizon!,
  $days: PositiveInt
) {
  model(id: $modelId) {
    simulation (
      positionSet: $positionSet
      base: $base
      from: $date
      to: $date
    ) {
      factorSensitivity (
        type: $factorSensitivityType
        horizon: $horizon
        days: $days
      ) {
        factors {
          id
          name
          category
          sensitivity
        }
      }
    }
  }
}`

export function createFactorSensitivitySingleDateQuery(modelId, positionSet, base, date, factorSensitivityType, options = {}) {
  return {
    key: ["factorSensitivity", factorSensitivityType, "singleDate", modelId, positionSet, base, date],
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      date,
      horizon: "MONTHLY",
      days: factorSensitivityType === "historical" ? FACTOR_SENSITIVITY_LOOKBACK_DAYS : undefined,
      factorSensitivityType: toUpper(factorSensitivityType),
    },
    select: (data) => {
      const values = chain(data)
        .get("data.model.simulation.factorSensitivity.0.factors")
        .thru(factors => {
          if (options.category) {
            return filter(factors, f => f.category === options.category)
          }
          return factors
        })
        .keyBy("id")
        .mapValues(({ name, sensitivity }) => ({
          label: name,
          value: sensitivity,
        }))
        .value()

      return {
        values,
      }
    },
  }
}
